import { render, staticRenderFns } from "./MdtTableList.vue?vue&type=template&id=2539d020&scoped=true"
import script from "./MdtTableList.vue?vue&type=script&lang=js"
export * from "./MdtTableList.vue?vue&type=script&lang=js"
import style0 from "./MdtTableList.vue?vue&type=style&index=0&id=2539d020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2539d020",
  null
  
)

export default component.exports